module.exports = __webpack_public_path__ + "static/media/LogicWedge2_5_drag_4.05f112eb.png";